import { OreStack, OreStepper, OreText } from '@edenredespana/oreneta'
import { Trans, useTranslation } from 'react-i18next'

import { useContractNewProducts } from '@/Contract/ui/context'
import { productContractingTranslation } from '@/Contract/ui/contractTranslation'
import {
  ContractNewProductsStep1,
  ContractNewProductsStep2,
  ContractNewProductsStep3,
  ContractNewProductsStep4,
  ContractNewProductsStep5,
} from '@/Contract/ui/molecules'

const renderCurrentStep = (step: number): JSX.Element => {
  switch (step) {
    case 1:
      return <ContractNewProductsStep1 />
    case 2:
      return <ContractNewProductsStep2 />
    case 3:
      return <ContractNewProductsStep3 />
    case 4:
      return <ContractNewProductsStep4 />
    case 5:
      return <ContractNewProductsStep5 />
    default:
      return <ContractNewProductsStep1 />
  }
}

export const ContractNewProductsStepper = (): JSX.Element => {
  const { t } = useTranslation()
  const { contractProductStep } = useContractNewProducts()

  return (
    <OreStack  style={contractProductStep === 5 ? { paddingTop: '42px' } : undefined} space="large" placeContent="stretch">
      {contractProductStep !== 5 && (
        <OreText>
          <Trans t={t}>
            {t(productContractingTranslation.contractProductPage.introduction)}
          </Trans>
        </OreText>
      )}
      <OreStepper
        activeStep={contractProductStep}
        steps={[
          t(productContractingTranslation.contractProductPage.stepper.step1),
          t(productContractingTranslation.contractProductPage.stepper.step2),
          t(productContractingTranslation.contractProductPage.stepper.step3),
          t(productContractingTranslation.contractProductPage.stepper.step4),
          t(productContractingTranslation.contractProductPage.stepper.step5),
        ]}
      />
      {renderCurrentStep(contractProductStep)}
    </OreStack>
  )
}
